export const firebaseConfig = {
  "projectId": "studio-7311296854-3c6b5",
  "appId": "1:39580838842:web:337a07a89b2f06ddf4cb83",
  "apiKey": "AIzaSyAgr6izkvN9UVjoUqJVoJVriYu3s27s-J8",
  "authDomain": "studio-7311296854-3c6b5.firebaseapp.com",
  "measurementId": "",
  "messagingSenderId": "39580838842"
};
